import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	chatToolsConnectTableConnectedTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.chat-tools-connect-table-connected-text-non-final',
		defaultMessage: 'Connected',
		description: 'Transition home chat tools step table connected text',
	},
	chatToolsConnectTableConnectButtonTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.chat-tools-connect-table-connect-button-text-non-final',
		defaultMessage: 'Connect',
		description: 'Transition home chat tools step table connect button text',
	},
	redundantTenantTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.redundant-tenant-text-non-final',
		defaultMessage: "Can't connect",
		description: 'Transition home chat tools step table redundant tenant text',
	},
	redundantTenantTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.redundant-tenant-tooltip-non-final',
		defaultMessage: "You've already connected a Microsoft tenant with Jira Service Management.",
		description: 'Transition home chat tools step table redundant tenant tooltip',
	},
	givePermissionTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.give-permission-text-non-final',
		defaultMessage: 'Give permission',
		description: 'Transition home chat tools step table give permission text',
	},
	givePermissionTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.give-permission-tooltip-non-final',
		defaultMessage:
			"Microsoft Teams Administrator's permission is required to create chats, meetings, and post to channels in Microsoft Teams.",
		description: 'Transition home chat tools step table give permission tooltip',
	},
	copyLinkTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.copy-link-text-non-final',
		defaultMessage: 'Copy link',
		description: 'Transition home chat tools step table copy link text',
	},
	copyLinkTooltipNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.copy-link-tooltip-non-final',
		defaultMessage:
			'Share the link with your Teams Administrator to give permission to Jira Service Management.',
		description: 'Transition home chat tools step table copy link tooltip',
	},
});
